<template>
  <div>
    <div v-if="!shouldShouldAssets">
      <div class="d-flex align-center" v-if="selectedAsset">
        <img
          :src="selectedAsset.vaultIcon"
          height="34"
          width="34"
          :alt="selectedAsset.identity"
        />
        <div class="ml-4">
          <div class="heading-5 font-weight-medium text-uppercase">
            {{ selectedAsset.identity }}
          </div>
          <div class="text-6 font-weight-light gray--text mt-1">
            {{ selectedAsset.text }}
          </div>
        </div>
        <v-icon
          v-if="!readonly"
          class="align-self-start black--text"
          @click="shouldShouldAssets = true"
          >mdi-chevron-down</v-icon
        >
      </div>
    </div>
    <div v-else class="asset-list">
      <div class="d-flex align-center justify-space-between">
        <div class="text-5 font-weight-medium">Vault Asset</div>
        <div class="text-5 font-weight-medium">Available</div>
      </div>
      <div
        class="d-flex align-center justify-space-between mt-5 clickable"
        v-for="asset in assets"
        :key="asset.identity"
        @click="setAsset(asset)"
      >
        <div class="d-flex align-center">
          <img
            :src="asset.vaultIcon"
            height="34"
            width="34"
            :alt="asset.identity"
          />
          <div class="ml-4">
            <div class="heading-5 font-weight-medium text-uppercase">
              {{ asset.identity }}
            </div>
            <div class="text-6 font-weight-light gray--text mt-1">
              {{ asset.text }}
            </div>
          </div>
        </div>
        <div>
          <div class="heading-5 font-weight-medium text-uppercase text-right">
            <span v-if="balances && balances[asset.coin]">{{
              balances[asset.coin].value | numberFormat("0,0.000000", true)
            }}</span>
            <span v-else>{{ 0 | numberFormat("0,0.000000", true) }}</span>
          </div>
          <div class="text-6 font-weight-light gray--text mt-1 text-right">
            <span v-if="balances && balances[asset.coin]">
              ${{
                (getTokenPrice(asset.coin) * balances[asset.coin].value)
                  | currency
              }}
            </span>
            <span v-else>{{ 0 | currency }}</span>
          </div>
        </div>
      </div>
      <div class="mt-16">
        <c-btn class="width-100" is-default @click="shouldShouldAssets = false"
          >Cancel</c-btn
        >
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  computed: mapGetters({
    getTokenPrice: "appConfig/getTokenPriceInUsd",
  }),
  props: ["assets", "selectedAsset", "balances", "readonly"],
  data: () => ({
    search: "",
    shouldShouldAssets: false,
  }),
  methods: {
    setAsset(asset) {
      this.$emit("setAsset", asset);
      this.shouldShouldAssets = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.asset-list {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  z-index: 2;
  background-color: var(--main-bg);
}
</style>
